<template>
  <div class='add-block'>
    <div class='add-block__added-damage-text'>
      <!-- <div>Повреждение не выбрано</div> -->
      
    </div>
    <p-button
      label='Добавить повреждение'
      :disabled='buttonIsDisabled'
      @click='addDamage'
      class='p-button-sm'
    />
  </div>
</template>

<script>
export default {
  name: 'RecountTreesDamageAddDamageBlock',

  props: {
    reasonFirstMode: Boolean,
    selectedReason: Object,
    selectedSymptoms: Array
  },

  computed: {
    buttonIsDisabled() {
      if (!this.selectedReason || !this.selectedSymptoms.length) {
        return true;
      }

      return false;
    }
  },

  methods: {
    addDamage() {
      this.$emit('add-damage');
    }
  }
};
</script>

<style scoped>
  .add-block {
    display: flex;
    justify-content: space-between;
  }
</style>